import { filter, isEmpty } from 'lodash';
import { Schema, ValidationError, addMethod, array, string } from 'yup';

import { isValidPhoneNumber } from '@spacefill/uikit/src/components/PhoneField/phoneValidation.ts';

addMethod(array, 'uniqueProperty', function (propertyPath, message) {
    return this.test('unique', '', function (list) {
        const errors = [];

        list.forEach((item, index) => {
            const propertyValue = item?.propertyPath;

            if (propertyValue && filter(list, [propertyPath, propertyValue]).length > 1) {
                errors.push(
                    this.createError({
                        path: `${this.path}[${index}].${propertyPath}`,
                        message,
                    })
                );
            }
        });

        if (!isEmpty(errors)) {
            throw new ValidationError(errors);
        }

        return true;
    });
});

addMethod(Schema, 'isValidGmapAddress', function (message) {
    return this.test(
        'isValidGmapAddress',
        message,
        (value) => typeof value === 'object' && value !== null && value.formattedAddress !== undefined
    );
});

addMethod(string, 'email', function validateEmail(message) {
    return this.matches(/^[\w._%\-+]+@[\w._%-]+\.[A-Za-z]{2,8}$/i, {
        message,
        name: 'email',
        excludeEmptyString: true,
    });
});

addMethod(string, 'hex', function validateHexColor(message) {
    return this.matches(/^#[0-9A-F]{6}[0-9a-f]{0,2}$/i, {
        message,
        name: 'hex',
        excludeEmptyString: true,
    });
});

addMethod(string, 'phoneNumber', function validatePhoneNumber(country, message) {
    return this.test('phoneNumber', message || "Le numéro de téléphone n'est pas valide", (value) => {
        if (!value) return true;
        return isValidPhoneNumber(value, country);
    });
});
